import { Button, Group, Text, Collapse, Box } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as CaretIcon } from "../assets/CaretDown.svg";
import "./customFaq.css";

const CustomFaq = ({ content, title }) => {
  const [opened, { toggle }] = useDisclosure(false);
  return (
    <div className="faq-item-wrapper">
      <div onClick={toggle} className="faq-item">
        <p className="faq-title">{title}</p>

        <span className="faq-caret-icon">
          <CaretIcon />
        </span>
      </div>
      <Collapse in={opened}>
        <Text className="collapse-text">{content}</Text>
      </Collapse>
    </div>
  );
};

export default CustomFaq;
